// extracted by mini-css-extract-plugin
export var locationCard = "_gh-0";